module.exports = __webpack_public_path__ + "img/dc580ac.png";